const Common = {
  country: {
    url: "/country",
    method: "GET",
  },
  state: {
    url: "/state",
    method: "GET",
  },
  notification: {
    url: "/notification",
    method: "GET",
  },
  notificationStatus: {
    url: "/notification/status",
    method: "PUT",
  },
  unreadNotificationCount: {
    url: "/unread-notification-count",
    method: "GET",
  },
  verifyMemorialToken: {
    url: "/verify/memorial-token",
    method: "POST",
  },
};
export default Common;
